/**
 * @module BrandsPreview
 */
// eslint-disable-next-line no-unused-vars
import jqueryMenuAim from 'jquery-menu-aim';
import Component from '../base/Component';
import './styles.css';

/**
 * Название компонента.
 */
export default class BrandsPreview extends Component {
    static className = 'brands-preview';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}

/* Логика для подменю Брендов. Увеличение области реакции. Применяем плагин для расширения "области реакции" при переходе на подменю по диагонали */

function initCatalogMenuAim(selector) {
    $(selector).menuAim({
        activate: onActivateMenuRow,
        deactivate: onDeactivateMenuRow,
        rowSelector: '> a',
    });
}

initCatalogMenuAim('.brands-preview__nav');

function onActivateMenuRow(listItem) {
    const $brandId = $(`#${$(listItem).data('brand')}`);

    // фиксим баг незакрытого пункта меню, если изначально не навели на открытый
    const $menuItems = document.querySelector('.brands-preview__nav-link');
    $menuItems.classList.remove('is-active');
    document.querySelector(`#${$menuItems.dataset.brand}`).classList.remove('is-active');

    $(listItem).addClass('is-active');
    $brandId.addClass('is-active');
}

function onDeactivateMenuRow(listItem) {
    const $brandId = $(`#${$(listItem).data('brand')}`);

    $(listItem).removeClass('is-active');
    $brandId.removeClass('is-active');
}
